import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * PasswordInput — a password field with a right-side eye icon that toggles
 * visibility. Drop-in replacement for `<Input type="password" .../>` anywhere.
 * Forwards refs and passes through every other prop (data-testid, className, etc.).
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", ...props },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        tabIndex={-1}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-stone hover:text-charcoal p-1 transition-colors"
        data-testid={`${props["data-testid"] || "password"}-toggle`}
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
});

export default PasswordInput;
